import {ConnectWrapper} from "features/hive/ui/HiveBody/styles.ts";
import {Button} from "@atomaro/ui-kit";
import connectModule from "/src/shared/assets/img/connect_module.png";
import {useNewDeviceModalStore} from "entities/newDeviceModal";
import {useCurrentHiveStore} from "entities/currentHive";


export const HiveBodyConnect = () => {
    const openConnect = useNewDeviceModalStore((s) => s.open)
    const currentHive = useCurrentHiveStore(s => s.currentHive)

    return (
        <ConnectWrapper>
            <h2>Подключите телеметрию для точного отслеживания показателей улья</h2>
            <img src={connectModule} alt={""}/>
            <Button
                size={"m"}
                onClick={() => openConnect(currentHive?.id || "", currentHive?.number || "")}
                label={"Подключить"}
                style={{width: "max-content"}}
            />
        </ConnectWrapper>
    );
};

